import { getBootstrapData } from "@swa-ui/bootstrap";
import { swaDate } from "@swa-ui/date";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const getDepartureDateSchema = (vacationsFirstDepartureDate) => {
  const airDatesData = getBootstrapData("air/air-dates-data");
  const lastBookableDate = swaDate(airDatesData.currentLastBookableDate).add(1, "day");
  const formattedFirstDepartureDate =
    vacationsFirstDepartureDate && swaDate(vacationsFirstDepartureDate);
  // Regular validation for Vacations is a date after today, but when we're transitioning from ALG, we send a date in the future that is
  // also the first available date to select, so the error needs to show the day before that date.
  const validateWithALGTransitionDate =
    formattedFirstDepartureDate && formattedFirstDepartureDate.isAfter(swaDate());
  const firstBookableDate = validateWithALGTransitionDate ? formattedFirstDepartureDate : swaDate();
  const minDateValidation = validateWithALGTransitionDate
    ? firstBookableDate.subtract(1, "day")
    : firstBookableDate;

  return yup
    .string()
    .test(
      "FirstBookableDate-MinDate",
      i18n("schema__ERROR_MIN_DATE", minDateValidation.format("MM/DD/YYYY")),
      (value) => swaDate(value).isSameOrAfter(firstBookableDate)
    )
    .test(
      "FirstBookableDate-MaxDate",
      i18n("schema__ERROR_MAX_DATE", lastBookableDate.format("MM/DD/YYYY")),
      (value) => swaDate(value).isBefore(lastBookableDate)
    )
    .test("ValidDate", i18n("schema__INVALID_DEPART_DATE"), (departureDateValue) =>
      swaDate(departureDateValue, "MM/DD/YYYY", true).isValid()
    )
    .required()
    .label(i18n("schema__DEPART_DATE").toLowerCase());
};

export const getReturnDateSchema = (vacationsFirstDepartureDate) => {
  const airDatesData = getBootstrapData("air/air-dates-data");
  const lastBookableDate = swaDate(airDatesData.currentLastBookableDate).add(1, "day");

  const firstBookableDate = vacationsFirstDepartureDate
    ? swaDate(vacationsFirstDepartureDate)
    : swaDate().set("date", swaDate().get("date"));

  return yup
    .string()
    .test(
      "LastBookableDate-MinDate",
      i18n("schema__ERROR_MIN_DATE", firstBookableDate.subtract(1, "day").format("MM/DD/YYYY")),
      (value) => swaDate(value).isSameOrAfter(firstBookableDate)
    )
    .test(
      "LastBookableDate-MaxDate",
      i18n("schema__ERROR_MAX_DATE", lastBookableDate.format("MM/DD/YYYY")),
      (value) => swaDate(value).isBefore(lastBookableDate, "day")
    )
    .test("ValidDate", i18n("schema__INVALID_RETURN_DATE"), (returnDateValue) =>
      swaDate(returnDateValue, "MM/DD/YYYY", true).isValid()
    )
    .required()
    .label(i18n("schema__RETURN_DATE").toLowerCase());
};
